// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-1aHx0","duration":"duration-3fN94","aircraft__name__link":"aircraft__name__link-2NH2d"};